<template>
    <form-row title="Title Commitment Due Date">
        <div class="flex flex-col sm:flex-row sm:items-end">
            <div class="-mt-4">
                <input-date
                    label="Date"
                    name="title_commitment_due_date"
                    v-model="title_commitment_due_date"
                    :read_only="read_only"
                    @entered="dateEntered"
                />
            </div>

            <div class="mt-4 sm:mt-0 flex items-center">
                <span class="flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                    {{ $t('- OR -') }}
                </span>

                <div class="flex-none w-16 sm:w-1/5">
                    <input-text
                        name="title_commitment_due_period"
                        v-model="title_commitment_due_period"
                        placeholder="Days"
                        :read_only="read_only"
                        @input="periodEntered"
                    />
                </div>

                <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                    {{ $t('days after Feasibility') }}
                </span>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            title_commitment_due_date: this.commercial.title_commitment_due_date,
            title_commitment_due_period: this.commercial.title_commitment_due_period,
        }
    },

    computed: {
        title_commitment_due_date_from_period() {
            if (! store.state.feasibility_date) {
                return;
            }

            if (this.isValidDate(store.state.feasibility_date) && this.title_commitment_due_period) {
                return dayjs(store.state.feasibility_date.slice(0, 10))
                    .add({ day: this.title_commitment_due_period })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.title_commitment_due_period = null;
        },
        periodEntered(value) {
            if (! value || ! store.state.feasibility_date) {
                this.title_commitment_due_date = null;
            }
        },
    },

    watch: {
        title_commitment_due_date_from_period(val) {
            if (val) {
                this.title_commitment_due_date = val;
            }
        },
        title_commitment_due_date(val) {
            this.$emit('updated', val);
        },
    },
}
</script>
